import { type ReactNode } from 'react'
import { useInView } from '@/hooks/useInView'
import { cn } from '@/lib/utils'

interface RevealProps {
  children: ReactNode
  className?: string
  /** Stagger delay in ms — use for sequential items in a list/grid. */
  delay?: number
  as?: 'div' | 'section' | 'li' | 'article'
}

/**
 * Scroll-triggered fade-and-rise. The single, site-wide entrance animation
 * so every section shares the same motion language. Reduced-motion users get
 * the content instantly (handled in useInView).
 */
export default function Reveal({ children, className, delay = 0, as = 'div' }: RevealProps) {
  const { ref, inView } = useInView<HTMLDivElement>()
  const Tag = as as 'div'

  return (
    <Tag
      ref={ref}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      className={cn(
        'transition-all duration-700 ease-out motion-reduce:transition-none',
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8',
        className
      )}
    >
      {children}
    </Tag>
  )
}
